module.exports = __webpack_public_path__ + "img/badge-success.f2698a23.svg";